import React, { useState,useEffect } from 'react';
import styled from 'styled-components';
import { Save, Upload, ArrowLeft, Plus } from 'lucide-react';

// 추가 스타일 컴포넌트
const SelectWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const AddButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background-color: #0f172a;
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  flex-shrink: 0;
  
  &:hover {
    background-color: #1e293b;
  }
`;

// 모달 스타일
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: white;
  border-radius: 0.5rem;
  padding: 1.5rem;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`;

const ModalTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
`;

const ModalCloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.25rem;
  color: #64748b;
  
  &:hover {
    color: #0f172a;
  }
`;

const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 1.5rem;
`;

const ModalButton = styled.button`
  padding: 0.5rem 1rem;
  background-color: ${props => props.primary ? '#0f172a' : 'white'};
  color: ${props => props.primary ? 'white' : '#0f172a'};
  border: 1px solid ${props => props.primary ? '#0f172a' : '#e2e8f0'};
  border-radius: 0.375rem;
  font-weight: 500;
  cursor: pointer;
  
  &:hover {
    background-color: ${props => props.primary ? '#1e293b' : '#f8fafc'};
  }
`;
// 스타일드 컴포넌트 정의
const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
`;

const BackLink = styled.a`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #64748b;
  text-decoration: none;
  font-weight: 500;
  cursor: pointer;
  
  &:hover {
    color: #0f172a;
  }
`;

const Title = styled.h1`
  font-size: 1.5rem;
  font-weight: 600;
  color: #0f172a;
`;

const Grid = styled.div`
  display: grid;
  gap: 1.5rem;
  
  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const Card = styled.div`
  background: white;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  border: 1px solid #e2e8f0;
`;

const CardHeader = styled.div`
  padding: 1.5rem;
  border-bottom: 1px solid #e2e8f0;
`;

const CardTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  color: #0f172a;
  margin: 0 0 0.5rem 0;
`;

const CardDescription = styled.p`
  font-size: 0.875rem;
  color: #64748b;
  margin: 0;
`;

const CardContent = styled.div`
  padding: 1.5rem;
`;

const ImageUploadArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
`;

const ImagePreviewContainer = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  background-color: #f1f5f9;
  border-radius: 0.5rem;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #94a3b8;
`;

const ImagePreview = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const UploadPlaceholder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 2rem;
  color: #64748b;
`;

const FileInput = styled.input`
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.375rem;
  font-size: 0.875rem;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const Label = styled.label`
  font-size: 0.875rem;
  font-weight: 500;
  color: #0f172a;
`;

const Input = styled.input`
  width: calc(100% - 0.75rem) ;
  padding: 0.5rem 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.375rem;
  font-size: 0.875rem;

  
  &:focus {
    outline: none;
    border-color: #94a3b8;
    box-shadow: 0 0 0 1px #94a3b8;
  }
`;

const Textarea = styled.textarea`
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  min-height: 120px;
  resize: vertical;
  
  &:focus {
    outline: none;
    border-color: #94a3b8;
    box-shadow: 0 0 0 1px #94a3b8;
  }
`;

const Select = styled.select`
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  background-color: white;
  
  &:focus {
    outline: none;
    border-color: #94a3b8;
    box-shadow: 0 0 0 1px #94a3b8;
  }
`;

const InputGroup = styled.div`
  position: relative;
  
  & > span {
    position: absolute;
    right: 0.75rem;
    top: 50%;
    transform: translateY(-50%);
    color: #64748b;
    pointer-events: none;
  }
`;

const TwoColumnGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
`;

const Divider = styled.hr`
  border: none;
  border-top: 1px solid #e2e8f0;
  margin: 1.5rem 0;
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0.75rem 1rem;
  background-color: #0f172a;
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #1e293b;
  }
  
  &:disabled {
    background-color: #94a3b8;
    cursor: not-allowed;
  }
`;

const SpinnerSvg = styled.svg`
  animation: spin 1s linear infinite;
  margin-right: 0.5rem;
  
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
// 오류 메시지 스타일
const ErrorMessage = styled.p`
  color: #ef4444;
  font-size: 0.75rem;
  margin-top: 0.25rem;
`;
function ProductRegistration() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [errors, setErrors] = useState({});
  const [imageFile, setImageFile] = useState(null);
  const [categories, setCategories] = useState([]);
  const [types, setTypes] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
    // 모달 관련 상태
    const [isTypeModalOpen, setIsTypeModalOpen] = useState(false);
    const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
    const [newTypeName, setNewTypeName] = useState('');
    const [newCategoryName, setNewCategoryName] = useState('');
    const [selectedParentType, setSelectedParentType] = useState('');
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    price: '',
    category: '',
    level: '',
    duration: '',
  });

// 타입 추가 핸들러
const handleAddType = async () => {
  if (!newTypeName.trim()) {
    alert('타입 이름을 입력해주세요.');
    return;
  }
  
  try {
    const response = await fetch('/api/addType', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ type_name: newTypeName }),
    });
    
    if (!response.ok) {
      throw new Error('타입 추가에 실패했습니다.');
    }
    
    const result = await response.json();
    
    // 타입 목록 갱신
    setTypes(prev => [...prev, { type_id: result.type_id, type_name: newTypeName }]);
    
    // 모달 닫기 및 입력값 초기화
    setIsTypeModalOpen(false);
    setNewTypeName('');
    
    alert('새 타입이 추가되었습니다.');
  } catch (error) {
    console.error('타입 추가 오류:', error);
    alert(`타입 추가 중 오류가 발생했습니다: ${error.message}`);
  }
};

// 카테고리 추가 핸들러
const handleAddCategory = async () => {
  if (!newCategoryName.trim()) {
    alert('카테고리 이름을 입력해주세요.');
    return;
  }
  
  if (!selectedParentType) {
    alert('상위 타입을 선택해주세요.');
    return;
  }
  
  try {
    const response = await fetch('/api/addCategory', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 
        category_name: newCategoryName,
        parent_type_id: selectedParentType
      }),
    });
    
    if (!response.ok) {
      throw new Error('카테고리 추가에 실패했습니다.');
    }
    
    const result = await response.json();
    
    // 현재 선택된 타입과 일치하면 카테고리 목록에 추가
    if (selectedParentType === formData.type) {
      setFilteredCategories(prev => [...prev, { 
        category_id: result.category_id, 
        category_name: newCategoryName 
      }]);
    }
    
    // 모달 닫기 및 입력값 초기화
    setIsCategoryModalOpen(false);
    setNewCategoryName('');
    setSelectedParentType('');
    
    alert('새 카테고리가 추가되었습니다.');
  } catch (error) {
    console.error('카테고리 추가 오류:', error);
    alert(`카테고리 추가 중 오류가 발생했습니다: ${error.message}`);
  }
};
  // 컴포넌트 마운트 시 카테고리와 타입 데이터 로드
// 컴포넌트 마운트 시 타입 데이터만 로드
useEffect(() => {
  const fetchTypes = async () => {
    setIsLoading(true);
    try {
      // 타입 데이터 로드
      const typeResponse = await fetch('/api/getTypes');
      if (!typeResponse.ok) {
        throw new Error('타입 목록을 불러오는데 실패했습니다.');
      }
      const typeData = await typeResponse.json();
      setTypes(typeData);
    } catch (error) {
      console.error('타입 데이터 로드 오류:', error);
      alert('타입 목록을 불러오는데 실패했습니다: ' + error.message);
    } finally {
      setIsLoading(false);
    }
  };
  
  fetchTypes();
}, []);
   // 타입 선택 시 해당 타입에 맞는 카테고리 조회
useEffect(() => {
  const fetchCategoriesByType = async () => {
    if (!formData.type) {
      setFilteredCategories([]);
      return;
    }
    
    try {
      const response = await fetch(`/api/getCategories?type_id=${formData.type}`);
      if (!response.ok) {
        throw new Error('카테고리 목록을 불러오는데 실패했습니다.');
      }
      const categoryData = await response.json();
      setCategories(categoryData);
      setFilteredCategories(categoryData);
      
      // 카테고리가 하나만 있으면 자동 선택
      if (categoryData.length === 1) {
        setFormData(prev => ({ ...prev, category: categoryData[0].prod_category }));
      }
    } catch (error) {
      console.error('카테고리 데이터 로드 오류:', error);
      alert('카테고리 목록을 불러오는데 실패했습니다: ' + error.message);
    }
  };
  
  fetchCategoriesByType();
}, [formData.type]); // 타입이 변경될 때마다 실행

  const validateForm = () => {
    const newErrors = {};
    
    // 제목 검증
    if (!formData.title.trim()) {
      newErrors.title = '상품명을 입력해주세요';
    } else if (formData.title.length > 100) {
      newErrors.title = '상품명은 100자 이내로 입력해주세요';
    }
    
    // 설명 검증
    if (!formData.description.trim()) {
      newErrors.description = '상품 설명을 입력해주세요';
    }
    
    // 가격 검증
    if (!formData.price) {
      newErrors.price = '가격을 입력해주세요';
    } else if (isNaN(formData.price) || Number(formData.price) < 0) {
      newErrors.price = '유효한 가격을 입력해주세요';
    }
    
    // 카테고리 검증
    if (!formData.category) {
      newErrors.category = '카테고리를 선택해주세요';
    }
    
    // 난이도 검증
    if (!formData.level) {
      newErrors.level = '난이도를 선택해주세요';
    }
    
    // 강의 시간 검증
    if (!formData.duration.trim()) {
      newErrors.duration = '강의 시간을 입력해주세요';
    }
    
    // 이미지 검증
    if (!imageFile && !imagePreview) {
      newErrors.image = '상품 이미지를 업로드해주세요';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // 오류가 없으면 true 반환
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    
    // 입력 필드 변경 시 해당 필드의 오류 메시지 제거
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: undefined }));
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      // 파일 크기 검증 (5MB)
      if (file.size > 5 * 1024 * 1024) {
        setErrors(prev => ({ ...prev, image: '이미지 크기는 5MB 이하여야 합니다' }));
        e.target.value = ''; // 파일 선택 초기화
        return;
      }
      
      setImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
      
      // 이미지 관련 오류 메시지 제거
      if (errors.image) {
        setErrors(prev => ({ ...prev, image: undefined }));
      }
    }
  };

  const uploadFile = async (file) => {
    if (!file) return null;
    
    const formData = new FormData();
    formData.append('files', file);
    
    try {
      const response = await fetch('https://file.skynet.re.kr/awsUpload/send?folder=store_antsnest', {
        method: 'POST',
        body: formData,
      });
      
      if (!response.ok) {
        throw new Error('파일 업로드에 실패했습니다');
      }
      
      const data = await response.json();
      // 응답 구조에 맞게 URL 추출
      if (data.files && data.files.length > 0) {
        return data.files[0].url;
      } else {
        throw new Error('업로드된 파일 정보를 찾을 수 없습니다');
      }
      
    } catch (error) {
      console.error('파일 업로드 오류:', error);
      throw new Error('이미지 업로드에 실패했습니다');
    }
  };

 // 상품 데이터 저장 함수
// 상품 데이터 저장 함수
const saveProduct = async (productData) => {
  try {
    const response = await fetch('/api/addProduct', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(productData),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || '상품 저장에 실패했습니다');
    }

    return await response.json();
  } catch (error) {
    console.error('상품 저장 오류:', error);
    throw new Error('상품 저장 중 오류가 발생했습니다: ' + error.message);
  }
};

// handleSubmit 함수 수정
const handleSubmit = async (e) => {
  e.preventDefault();
  
  // 폼 유효성 검사
  if (!validateForm()) {
    // 스크롤을 첫 번째 오류 필드로 이동
    const firstErrorField = document.querySelector('[aria-errormessage]');
    if (firstErrorField) {
      firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
      firstErrorField.focus();
    }
    return;
  }
  
  setIsSubmitting(true);
  
  try {
    // 이미지 업로드
    let imageUrl = null;
    if (imageFile) {
      imageUrl = await uploadFile(imageFile);
    }
    
    // 상품 데이터 구성 (mst_product_item 테이블 구조에 맞춤)
    const productData = {
      prod_name: formData.title,
      prod_desc: formData.description,
      prod_price: Number(formData.price),
      prod_type: formData.type, // 카테고리를 prod_type으로 매핑
      prod_category : formData.category,
      image_url: imageUrl, // 이미지 URL (별도 저장 필요)
      // 추가 메타데이터 (별도 테이블에 저장 필요)
      level: formData.level,
      duration: formData.duration,
    };
    
    // 상품 데이터 저장 API 호출
    const savedProduct = await saveProduct(productData);
    
    console.log('등록된 상품:', savedProduct);
    
    // 성공 알림
    alert(`상품 등록 완료\n${formData.title} 상품이 성공적으로 등록되었습니다.`);
    
    // 폼 초기화
    setFormData({
      title: '',
      description: '',
      price: '',
      category: '',
      level: '',
      duration: '',
    });
    setImagePreview(null);
    setImageFile(null);
    setErrors({});
    
    // 파일 인풋 초기화
    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput) fileInput.value = '';
    
  } catch (error) {
    console.error('상품 등록 오류:', error);
    alert(`상품 등록 중 오류가 발생했습니다: ${error.message}`);
  } finally {
    setIsSubmitting(false);
  }
};

 
  return (
    <Container>
      <Header>
        <BackLink href="#">
          <ArrowLeft size={20} />
          관리자 대시보드
        </BackLink>
        <Title>상품 등록</Title>
      </Header>

      <Grid>
        {/* 이미지 업로드 카드 */}
        <Card>
          <CardHeader>
            <CardTitle>상품 이미지</CardTitle>
            <CardDescription>
              상품 대표 이미지를 업로드해주세요. 권장 크기: 1280x720px
            </CardDescription>
          </CardHeader>
          <CardContent>
            <ImageUploadArea>
              <ImagePreviewContainer>
                {imagePreview ? (
                  <ImagePreview src={imagePreview || "/placeholder.svg"} alt="Preview" />
                ) : (
                  <UploadPlaceholder>
                    <Upload size={40} style={{ marginBottom: '0.5rem' }} />
                    <p style={{ fontSize: '0.875rem' }}>이미지를 드래그하거나 클릭하여 업로드하세요</p>
                    <p style={{ fontSize: '0.75rem', marginTop: '0.25rem' }}>PNG, JPG, GIF 최대 5MB</p>
                  </UploadPlaceholder>
                )}
              </ImagePreviewContainer>
              <FileInput
                name='files'
                type="file"
                accept="image/*"
                onChange={handleImageChange}
              />
            </ImageUploadArea>
          </CardContent>
        </Card>

        {/* 상품 정보 카드 */}
        <Card>
          <CardHeader>
            <CardTitle>상품 정보</CardTitle>
            <CardDescription>
              상품의 기본 정보를 입력해주세요.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Form onSubmit={handleSubmit}>
              <FormGroup>
                <Label htmlFor="title">상품명</Label>
                <Input
                  id="title"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  placeholder="예: React 완벽 가이드"
                  required
                />
              </FormGroup>

              <FormGroup>
                <Label htmlFor="description">상품 설명</Label>
                <Textarea
                  id="description"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="상품에 대한 상세 설명을 입력해주세요."
                  required
                />
              </FormGroup>

              <TwoColumnGrid>
                <FormGroup>
                  <Label htmlFor="type">타입</Label>
                  <SelectWrapper>
                    <Select
                      id="type"
                      name="type"
                      value={formData.type}
                      onChange={handleChange}
                      required
                      aria-errormessage={errors.type ? "type-error" : undefined}
                    >
                      <option value="">타입 선택</option>
                      {types.map(type => (
                        <option key={type.type_id} value={type.type_id}>
                          {type.type_name}
                        </option>
                      ))}
                    </Select>
                    <AddButton type="button" onClick={() => setIsTypeModalOpen(true)}>
                      <Plus size={16} />
                    </AddButton>
                  </SelectWrapper>
                  {errors.type && <ErrorMessage id="type-error">{errors.type}</ErrorMessage>}
                </FormGroup>

                <FormGroup>
                  <Label htmlFor="category">카테고리</Label>
                  <SelectWrapper>
                    <Select
                      id="category"
                      name="category"
                      value={formData.category}
                      onChange={handleChange}
                      required
                      disabled={!formData.type || filteredCategories.length === 0}
                      placeholder='카테고리 선택'
                      aria-errormessage={errors.category ? "category-error" : undefined}
                    >
                      <option value="">카테고리 선택</option>
                      {filteredCategories.map(category => (
                        <option key={category.category_id} value={category.category_name}>
                          {category.category_name}
                        </option>
                      ))}
                    </Select>
                    <AddButton 
                      type="button" 
                      onClick={() => setIsCategoryModalOpen(true)}
                      disabled={!formData.type}
                    >
                      <Plus size={16} />
                    </AddButton>
                  </SelectWrapper>
                  {errors.category && <ErrorMessage id="category-error">{errors.category}</ErrorMessage>}
                </FormGroup>
              </TwoColumnGrid>
            
              <TwoColumnGrid>
                <FormGroup>
                  <Label htmlFor="level">난이도</Label>
                  <Select
                    id="level"
                    name="level"
                    value={formData.level}
                    onChange={handleChange}
                    required
                  >
                    <option value="" disabled>난이도 선택</option>
                    <option value="beginner">입문</option>
                    <option value="intermediate">초급</option>
                    <option value="advanced">중급</option>
                    <option value="expert">고급</option>
                  </Select>
                </FormGroup>

                <FormGroup>
                  <Label htmlFor="duration">강의 시간</Label>
                  <Input
                    id="duration"
                    name="duration"
                    value={formData.duration}
                    onChange={handleChange}
                    placeholder="예: 8시간 30분"
                    required
                  />
                </FormGroup>
                <FormGroup>
                    <Label htmlFor="price">가격</Label>
                    <InputGroup>
                      <Input
                        id="price"
                        name="price"
                        type="number"
                        value={formData.price}
                        onChange={handleChange}
                        placeholder="0"
                        min="0"
                        required
                        aria-errormessage={errors.price ? "price-error" : undefined}
                      />
                      <span>원</span>
                    </InputGroup>
                    {errors.price && <ErrorMessage id="price-error">{errors.price}</ErrorMessage>}
                  </FormGroup>
              </TwoColumnGrid>

              <Divider />

              <Button type="submit">
                {isSubmitting ? (
                  <>
                    <SpinnerSvg width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </SpinnerSvg>
                    상품 등록 중...
                  </>
                ) : (
                  <>
                    <Save size={16} style={{ marginRight: '0.5rem' }} />
                    상품 등록하기
                  </>
                )}
              </Button>
            </Form>
          </CardContent>
        </Card>
      </Grid>
      {isTypeModalOpen && (
        <ModalOverlay>
          <ModalContent>
            <ModalHeader>
              <ModalTitle>신규 타입 추가</ModalTitle>
              <ModalCloseButton onClick={() => setIsTypeModalOpen(false)}>×</ModalCloseButton>
            </ModalHeader>
            <FormGroup>
              <Label htmlFor="newTypeName">타입 이름</Label>
              <Input
                id="newTypeName"
                value={newTypeName}
                onChange={(e) => setNewTypeName(e.target.value)}
                placeholder="새 타입 이름 입력"
              />
            </FormGroup>
            <ModalFooter>
              <ModalButton onClick={() => setIsTypeModalOpen(false)}>취소</ModalButton>
              <ModalButton primary onClick={handleAddType}>추가</ModalButton>
            </ModalFooter>
          </ModalContent>
        </ModalOverlay>
      )}
      
      {/* 카테고리 모달 */}
      {isCategoryModalOpen && (
        <ModalOverlay>
          <ModalContent>
            <ModalHeader>
              <ModalTitle>신규 카테고리 추가</ModalTitle>
              <ModalCloseButton onClick={() => setIsCategoryModalOpen(false)}>×</ModalCloseButton>
            </ModalHeader>
            <FormGroup>
              <Label htmlFor="parentType">상위 타입</Label>
              <Select
                id="parentType"
                value={selectedParentType}
                onChange={(e) => setSelectedParentType(e.target.value)}
                required
              >
                <option value="">타입 선택</option>
                {types.map(type => (
                  <option key={type.type_id} value={type.type_id}>
                    {type.type_name}
                  </option>
                ))}
              </Select>
            </FormGroup>
            <FormGroup>
              <Label htmlFor="newCategoryName">카테고리 이름</Label>
              <Input
                id="newCategoryName"
                value={newCategoryName}
                onChange={(e) => setNewCategoryName(e.target.value)}
                placeholder="새 카테고리 이름 입력"
              />
            </FormGroup>
            <ModalFooter>
              <ModalButton onClick={() => setIsCategoryModalOpen(false)}>취소</ModalButton>
              <ModalButton primary onClick={handleAddCategory}>추가</ModalButton>
            </ModalFooter>
          </ModalContent>
        </ModalOverlay>
      )}
    </Container>
  );
}

export default ProductRegistration;